import { createFileRoute } from '@tanstack/react-router'

import { DepositPaymentPage } from '@/components/deposit-payment/deposit-payment-page'
import { depositSearchSchema } from '@/lib/schemas/deposit-payment/deposit-payment.schema'

export const Route = createFileRoute('/_blue_header/payer-acompte/')({
  component: RouteComponent,
  validateSearch: depositSearchSchema,
})

export function RouteComponent() {
  const searchParams = Route.useSearch()

  return <DepositPaymentPage initialValues={searchParams} mode={searchParams.mode} />
}
